export default class TotalPoint {
  amount: number;

  constructor(data?: Partial<TotalPoint>) {
    Object.assign(this, data);
  }
}
